'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-test-renderer.production.min.js');
} else {
  module.exports = require('./cjs/react-test-renderer.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/react-test-renderer/index.js
// module id = 1207
// module chunks = 168707334958949